import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FoodWizard } from '@chewy/pet-profile-food-wizard';
import '@chewy/pet-profile-food-wizard/dist/esm/main.css';
import { Helmet } from 'react-helmet-async';
import { useQuery } from 'react-query';
import CmsNonSku from '@chewy/cms-non-sku';
import { CMS_URL, ENV } from '../util/config';
import { retryCount } from '../util/reactQueryOptions';
import { isNotChewyMobileApp } from '../util/helpers';
import AnalyticsContext from '../context/AnalyticsContext';
import loadCms, { getZone, selectStandardNonSkuComponents } from '../api/CmsApi';
import { ApiContentPage, ApiZone } from '../api/generated-client/Content-Service-A.v1';
import { CMS_FOOD_FINDER_GENERAL_TYPE, FOOD_FINDER_ZONE } from '../api/CmsApiConstants';
import FoodWizardBanner from '../components/food-wizard/FoodWizardBanner';
import '@chewy/kib-carousels-styles/dist/styles/kib-carousel.css';
import '@chewy/kib-content-groups-styles/dist/styles/kib-section-heading.css';
import '@chewy/kib-chips-styles/dist/styles/kib-chip-action.css';
import '@chewy/cms-non-sku/dist/cms-non-sku.css';
import './food-finder.scss';

export default function FoodWizardPage() {
  const location = useLocation();
  const [showWizard, setShowWizard] = useState<boolean>(
    !isNotChewyMobileApp() && location.hash === '#modal',
  );
  const { trackEvent } = useContext(AnalyticsContext);

  const getRelevantCmsContent = (data: ApiContentPage): ApiZone => {
    // request from the first zone
    const selectedZone = getZone(FOOD_FINDER_ZONE - 1, data);
    // filter what's in the first zone by the standard non sku components
    const filteredZoneData = selectStandardNonSkuComponents(selectedZone!);
    return filteredZoneData;
  };

  const { isLoading: cmsFoodFinderLoading, data: cmsFoodFinderData } = useQuery(
    [null, null, CMS_FOOD_FINDER_GENERAL_TYPE],
    loadCms,
    {
      select: getRelevantCmsContent,
      retry: retryCount,
    },
  );

  const pageLoading = cmsFoodFinderLoading;

  return pageLoading ? (
    <div>
      <Helmet />
    </div>
  ) : (
    <div className="food-finder-landing">
      <Helmet>
        <title>Fresh & Prepared Food Finder | Chewy.com</title>
      </Helmet>

      <FoodWizardBanner
        onClickCallback={() => {
          setShowWizard(true);

          if (!isNotChewyMobileApp()) {
            window.location.hash = 'modal';
          }
        }}
      />

      {cmsFoodFinderData && cmsFoodFinderData.components.length > 0 && (
        <div className="kib-container">
          <CmsNonSku data={cmsFoodFinderData.components[0]} />
        </div>
      )}

      {showWizard && (
        <FoodWizard
          show={showWizard}
          env={ENV}
          searchUrl="/pets/api/proxy"
          dotCmsUrl={CMS_URL}
          onClose={() => {
            setShowWizard(false);
            if (!isNotChewyMobileApp()) {
              window.location.hash = '';
            }
          }}
          analyticsClient={{
            trackEvent: trackEvent,
          }}
        />
      )}
    </div>
  );
}
